export default function Footer() {
  return (
    <footer id="footer" className="w-full bg-secondary-100 text-foreground-700">
      <div className="px-4 md:px-6 max-w-6xl mx-auto py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="sm:col-span-2 lg:col-span-1">
            <span className="text-xl font-heading font-bold text-foreground-900">6080影视</span>
            <p className="text-sm text-foreground-500 mt-3 leading-relaxed">
              依托6080新视觉影视资源，提供免费高清电影在线观看服务。
              海量电影大全，每日更新，高清画质不缓冲流畅播放，免VIP畅享观影。
            </p>
            <div className="flex items-center gap-3 mt-4">
              <a href="#hero" className="w-8 h-8 flex items-center justify-center rounded-full bg-secondary-200 text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#hero" className="w-8 h-8 flex items-center justify-center rounded-full bg-secondary-200 text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#hero" className="w-8 h-8 flex items-center justify-center rounded-full bg-secondary-200 text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">
                <i className="ri-bilibili-line"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-bold text-foreground-900 mb-3">快速导航</h4>
            <ul className="space-y-2">
              <li><a href="#index" className="text-sm text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer">电影专题</a></li>
              <li><a href="#ranking" className="text-sm text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer">热门榜单</a></li>
              <li><a href="#carousel" className="text-sm text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer">焦点推荐</a></li>
              <li><a href="#cards" className="text-sm text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer">精选推荐</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold text-foreground-900 mb-3">平台信息</h4>
            <ul className="space-y-2">
              <li><a href="#about" className="text-sm text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer">关于6080</a></li>
              <li><a href="#updates" className="text-sm text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer">最新动态</a></li>
              <li><a href="#faq" className="text-sm text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer">常见问题</a></li>
              <li><a href="#contact" className="text-sm text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer">联系我们</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold text-foreground-900 mb-3">合作伙伴</h4>
            <p className="text-sm text-foreground-500 leading-relaxed">
              感谢所有合作伙伴的支持与信任，共同打造优质观影生态。
            </p>
          </div>
        </div>

        <div className="border-t border-secondary-300/60 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-400">
            &copy; 2026 6080影视 - 6080新视觉影视 版权所有
          </p>
          <p className="text-xs text-foreground-400">
            免费高清电影在线观看 · 不缓冲流畅播放 · 每日更新
          </p>
        </div>
      </div>
    </footer>
  );
}